export default "__VITE_ASSET__fx1QGaxv__"